import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase.init';
import { collection, addDoc } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMailForward } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Loading from '../Shared/Loading';
import ContactBackground from '../../assets/images/ContactBackground.jpg';

const Contact = () => {
    const [isLoading, setLoading] = useState(false);

    const userCollectionRef = collection(db, "users");

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const form = useRef();

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        const name = form.current.name.value;
        const email = form.current.email.value;
        const message = form.current.message.value;

        const date = new Date().toISOString();
        await addDoc(userCollectionRef, { name, email, date, message });
        await setLoading(false);
        await toast.success('Massage Send Successfully. Thanks. I will try to respond to your message as soon as possible ! 🙂', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            style: {
                marginTop: '5rem',
                color: '#00ff00',
                background: '#00283a80',
                fontFamily: 'font-Cormorant-Garamond',
                border: "1px solid #194151",
                filter: "drop-shadow(16px 16px 20px #194170)"
            }
        });
        await e.target.reset();
    };
    if (isLoading) {
        return <Loading />
    };
    return (
        <div>
            <section className='py-2 sm:py-4 lg:py-6 min-h-screen flex flex-col items-center text-white px-2 sm:px-4 md:px-2' >
                <div className='relative w-full md:w-5/6 lg:w-4/5 xl:w-3/4 2xl:w-1/2 rounded md:rounded-md lg:rounded-xl shadow-[#000000b0] shadow-2xl overflow-hidden border-[1px] border-gray-600' data-aos="fade-down">
                    <img className='opacity-30 h-80 sm:h-[27rem] flex w-full' style={{ filter: 'blur(16px)' }} src={ContactBackground} alt="" />
                    <div className='absolute top-0 w-full'>
                        {/* <div className='text-3xl pt-8 pb-4 font-bold uppercase text-center text-transparent bg-clip-text bg-gradient-to-r  from-[#728fa5fa] to-[#fbfeffe5]'>Contact Me</div> */}
                        <h2 className='text-[#ffffff70] w-full text-center text-lg sm:text-2xl pt-3 sm:pt-5 Black-Ops-One'>Contact Witn Me</h2>
                        <div className='px-4 sm:px-7 flex flex-col items-center font-Cormorant-Garamond'>
                            <form ref={form} onSubmit={handleSubmit} className='w-full'>
                                <div className="form-control w-full">
                                    <span className="label-text text-white text-sm sm:text-lg">Your Name</span>
                                    <input type="text" placeholder="Please Provide Your Name" className=" focus:text-green-500 focus:outline-none focus:font-play bg-[#00000070] rounded text-sm sm:text-lg h-7 sm:h-9 input input-xs w-full" name="name" required />
                                </div>
                                <div className="form-control w-full">
                                    <span className="label-text text-white py-1 text-sm sm:text-lg">Your Email Address</span>
                                    <input type="email" placeholder="Please Provide Your Email Address" className="focus:text-green-500 focus:outline-none bg-[#00000070] rounded text-sm sm:text-lg h-7 sm:h-9 input input-xs w-full" name="email" required />
                                </div>
                                <div className="form-control w-full">
                                    <span className="label-text text-white py-1 rounded text-sm sm:text-lg">Massage</span>
                                    <textarea placeholder="Please a massage that you want to send me..." className="focus:text-green-500 focus:outline-none  bg-[#00000070] rounded text-sm sm:text-lg h-20 sm:h-28 input input-xs w-full" name="message" required></textarea>
                                </div>
                                <div className='mt-1 sm:mt-3'>
                                    <button className="mb-1 mt-2 btn btn-xs sm:btn-sm capitalize w-36 sm:w-60 h-7 sm:h-9 font-play font-light rounded text-xs sm:text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600">
                                        <input className='cursor-pointer' type="submit" value="Send" />
                                        <FontAwesomeIcon className='ml-2' icon={faMailForward} />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;